import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  html {
    -webkit-font-smoothing: antialiased;
  }

  .layout.RaLayout-root-1 {
    background-color: #F4F7F9;
  }

  .MuiIconButton-root:hover {
    background-color: rgba(199, 209, 218, 0.4);
  }

  [class*=RaNotification-success] {
    color: white;
  }

  .layout {
    z-index: unset;
  }
`
